module.exports = __webpack_public_path__ + "img/icon_search.b870b3b0.svg";